module.exports = __webpack_public_path__ + "img/IMG_2537-2.cb3cfa4b.jpg";